<div class="skeleton">
  @for (row of numberOfRows; track index; let index = $index) {
    <div class="skeleton__row">
      @for (col of numberOfCols; track index2; let index2 = $index) {
        <div class="skeleton__row--col"></div>
      }
    </div>
  }
</div>
